export enum ParamSourceTypes {
  Value = 'value',
  Variable = 'variable',
  Expression = 'expression',
  Other = 'other',
}
